module.exports = __webpack_public_path__ + "static/media/BeerProduction.493bbaca.gif";